"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.165 8.881a.7.7 0 0 1 .7.7v7.048a.7.7 0 1 1-1.4 0V9.58a.7.7 0 0 1 .7-.7m3.417.001a.7.7 0 0 1 .7.7v7.048a.7.7 0 1 1-1.4 0V9.58a.7.7 0 0 1 .7-.7M12 8.881a.7.7 0 0 1 .7.7v7.048a.7.7 0 1 1-1.4 0V9.58a.7.7 0 0 1 .7-.7m3.418.001a.7.7 0 0 1 .7.7v7.048a.7.7 0 1 1-1.4 0V9.58a.7.7 0 0 1 .7-.7m3.417.001a.7.7 0 0 1 .7.7v7.048a.7.7 0 1 1-1.4 0V9.58a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.952 4.754a2.3 2.3 0 0 0-1.904 0L4.794 7.598a.672.672 0 0 0 .278 1.283h13.856a.672.672 0 0 0 .278-1.283zM10.469 3.48a3.7 3.7 0 0 1 3.062 0l6.255 2.843a2.072 2.072 0 0 1-.858 3.958H5.072a2.072 2.072 0 0 1-.858-3.958zM3.178 18.129a2.2 2.2 0 0 1 2.2-2.2h13.244a2.2 2.2 0 0 1 2.2 2.2v.523a2.2 2.2 0 0 1-2.2 2.2H5.378a2.2 2.2 0 0 1-2.2-2.2zm2.2-.8a.8.8 0 0 0-.8.8v.523a.8.8 0 0 0 .8.8h13.244a.8.8 0 0 0 .8-.8v-.523a.8.8 0 0 0-.8-.8z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BankIcon24.js.map